<app-header></app-header>
<!-- breadcrumb section start -->
<section class="breadcrumb-section-main inner-2 breadcrumb-section-sm">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumb-contain ">
          <div>
            <h2 class="breadcrumb-txt">Sectors</h2>
          </div>
          <div>
            <ul>
              <li><a class="white" href="javascript:void()">List Sectors</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--breadcrumb section end -->
<!-- section start -->


<section class="agency blog blog-sec blog-sidebar blog-split sider">
  <div class="container">
    <div class="row pl-0 pr-0">
      <div class="col-lg-10">
        <div class="row">

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/lvt_straight.jpg" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">LVT Straight Plank</h5>
                        <p class="para2"></p>
                        <p>Traditional straight plank LVT, hundreds of choices to perfectly match the colour pallete
                        of the installation environment. Four stocked ranges, suiting all installation budgets.</p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/7']" [queryParams]="{category: 'lvt-straight-plank'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/lvt_hbone.jpg" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">LVT Herringbone</h5>
                        <p class="para2"></p>
                        <p>A timeless classic, herringbone flooring is a surefire way to elevate any space. We have 40 options for
                          herringbone design flooring, perfectly matching our straight plank options.
                        </p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/8']" [queryParams]="{category: 'lvt-herringbone'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>




        </div>
        <!-- new row second fix-->
        <div class="row">

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/lvt_stone.jpg" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">LVT Stones</h5>
                        <p class="para2"></p>
                        <p>Looking for a stone or porcelain floor? But with the warmth and versatility of LVT? Look no further.
                          Our ranges of stone LVT feature ultra-realistic textures and embossing to have your clients questioning
                          their authenticity.
                        </p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/9']" [queryParams]="{category: 'lvt-stone-effect'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/lvt_design.png" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">LVT Designs</h5>
                        <p class="para2"></p>
                        <p>If you want a wood effect floor, but want a truly show stopping design, then a design timber floor is for you.
                        Featuring multiple designs, look at some of the ranges in this category for a truly unique floor.</p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/10']" [queryParams]="{category: 'lvt-design-panels'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- new row second fix-->

        <div class="row">

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/lvt_victorian.jpeg" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">LVT Victorian</h5>
                        <p class="para2"></p>
                        <p>Seeking that classic look for your hallway or living space? Take a look at the limitless options
                          available with our Creo Victorian LVT, a mix of designs and colours can create showpiece floors that are
                        truly unique.</p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/11']" [queryParams]="{category: 'lvt-victorian-tiles'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/wood_straight.jpg" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">Wood - Straight Plank</h5>
                        <p class="para2"></p>
                        <p>Flooring as its been for hundreds of years, wooden straight plank. Available in multiple
                          colours, finishes, species and thicknesses. If you are looking for a wooden floor, we will have
                          the finish you need.
                        </p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/12']" [queryParams]="{category: 'wood-straight-plank'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- new row second fix-->


        <div class="row">

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/wood_hbone.jpg" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">Wood - Herringbone</h5>
                        <p class="para2"></p>
                        <p>You simply cannot imitate the beauty of real wood flooring, especially in herringbone. As <thead>
                          the light catches each knot, board and grain differently you are sure to notice minute feature
                          differences each time your eyes gaze across a real oak herringbone floor.
                        </thead>.</p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/13']" [queryParams]="{category: 'wood-flooring-herringbone'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/chevron.jpg" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">Wood - Chevron</h5>
                        <p class="para2"></p>
                        <p>There are two types of people when it comes to wood flooring, those who want chevron and those that don't.
                          You either love it or hate it! If you are in the love it category, then check out the options we have for sale.
                        </p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/14']" [queryParams]="{category: 'wood-flooring-chevron'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- new row second fix-->

        <div class="row">

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/laminate.jpg" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">Laminate</h5>
                        <p class="para2"></p>
                        <p>Wood designs on a high pressure base, Laminate flooring is an ideal solution for a long lasting, worry free
                          floor covering, that can transform a room within a day from start to finish. Click together and away you go.
                        </p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/15']" [queryParams]="{category: 'laminate-flooring'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/grass2.jpg" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">ArtificialGrass</h5>
                        <p class="para2"></p>
                        <p>Our artificial grass provides an ultra-realistic "mow free" lawn. We stock 3 qualities, all available
                        for next day delivery, along with all related installation ancillaries. </p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/16']" [queryParams]="{category: 'artificial-grass'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- new row second fix-->

        <div class="row">

          <div class="col-lg-6  col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/mapei1.png" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">Floor Levelling</h5>
                        <p class="para2"></p>
                        <p>Sadly there is no frills to floor levelling, however we do stock large amounts of self levelling
                          compounds to suit a variety of subfloors. There is really no "one size fits all" approach to levelling
                          compounds, so please feel free to call us for some free, expert advice.
                        </p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/17']" [queryParams]="{category: 'self-levelling-compounds'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12 blog-sec blog-list">
            <div class="blog-agency">
              <div class="row blog-contain pl-0 pr-0">
                <div class="col-xl-4 col-lg-4 col-md-4 p-0" [ngClass]="1%2==0?'order-md-2':''">
                  <div class=" text-center">
                    <img src="https://swc-website.s3.eu-west-1.amazonaws.com/static_images/second-fix/adhesive.png" alt="" class="img-fluid blog-img">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-7 col-md-6 p-0">
                  <div class="img-container center-content">
                    <div class="center-content">
                      <div class="blog-info">
                        <h5 class="blog-head font-600">Adhesives</h5>
                        <p class="para2"></p>
                        <p>All glues and adhesives for all of the products mentioned above, we also stock a range of primers,
                        DPM's and other remedial products.</p>
                        <div class="btn-bottom m-t-20">
                          <a [routerLink]="['/products/sector/18']" [queryParams]="{category: 'flooring-adhesives'}"
                          class="btn btn-default primary-btn info">Show Products</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- new row second fix-->

      </div>
      <div class="col-lg-2">
        <div class="blog-side">
          <div>
            <h5 class="blog-title">Second Fix Floors</h5>
            <div class="sidebar-container borders">
              Hard flooring is now a core part of the construction phase, with the majority of hard flooring
              installed before the kitchens and other second fix joinery such as skirting boards and architraves.
            </div>
          </div>
          <div>
            <h5 class="blog-title">Next Day Service</h5>
            <div class="sidebar-container">
              We know how immportant service is, many of our products shown here are stocked deeply in our warehouse,
              ready for next-day site delivery, across the UK.
            </div>


            @if (productFeature?.length) {
              <div class="sidebar-container">
                <h5 class="blog-title">Popular Products</h5>
                @for (product of productFeature; track product) {
                  <div class="">
                    <div class="center-content">
                      <a [routerLink]="['/products/view', product.slug]">
                        <img src="{{product.mainImageAWSURL}}" alt=""
                          class="img-fluid sidebarimage">
                      </a>
                      <h4 class="post-head grey">{{product.name}}</h4>
                      <h6 class="date grey">{{product.briefDescription}}</h6>
                    </div>
                    <br />
                  </div>
                }
              </div>
            }
          </div>

          <div>



          </div>
        </div>
      </div>
    </div>
  </div>
</section>



<!-- Section ends -->
<app-footer></app-footer>